import React from 'react';
import SimpleProductPage from './SimpleProductPage';
import { 
  findProductById, 
 
  getProductImage, 
  getProductCsvLookupId 
} from '../../utils/productHelpers';

const GarminEchomapUltra2126sv = () => {
  console.log('🎯 GarminEchomapUltra2126sv component loading');
  
  const product = findProductById("echomap-ultra-2-126sv");
  
  if (!product) {
    console.error('Product not found:', "echomap-ultra-2-126sv");
    return <div>Product not found</div>;
  }
  
  return (
    <SimpleProductPage 
      specificProductId="echomap-ultra-2-126sv"
      productName={product.name}
      productImage={getProductImage(product)}
      csvLookupId={getProductCsvLookupId(product)}
      csvExactMatchOnly={true}
    />
  );
};

export default GarminEchomapUltra2126sv; 